var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvoicePrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9719 15.272L33.8542 9.04628C33.1979 8.37844 32.3083 8 31.3823 8H16.5C14.5677 8.00742 13 9.60281 13 11.5692V42.4382C13 44.4046 14.5677 46 16.5 46H37.5C39.4323 46 41 44.4046 41 42.4382V17.795C41 16.8526 40.6281 15.9399 39.9719 15.272ZM38.324 16.9565C38.4771 17.1123 38.5792 17.2978 38.6302 17.5056H31.6667V10.4191C31.8708 10.471 32.0531 10.5749 32.2062 10.7307L38.324 16.9565ZM37.5 43.6255H16.5C15.8583 43.6255 15.3333 43.0912 15.3333 42.4382V11.5692C15.3333 10.9162 15.8583 10.382 16.5 10.382H29.3333V18.0992C29.3333 19.0861 30.1135 19.8801 31.0833 19.8801H38.6667V42.4382C38.6667 43.0912 38.1417 43.6255 37.5 43.6255ZM34 26.5196V27.1133C34 27.603 33.6063 28.0037 33.125 28.0037H20.875C20.3937 28.0037 20 27.603 20 27.1133V26.5196C20 26.0299 20.3937 25.6292 20.875 25.6292H33.125C33.6063 25.6292 34 26.0299 34 26.5196ZM34 34.0178V34.6114C34 35.1012 33.6063 35.5019 33.125 35.5019H20.875C20.3937 35.5019 20 35.1012 20 34.6114V34.0178C20 33.528 20.3937 33.1273 20.875 33.1273H33.125C33.6063 33.1273 34 33.528 34 34.0178Z",
    fill: "#335C75",
    stroke: "#335C75",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoicePrompt);
export default __webpack_public_path__ + "static/media/icon-invoice-prompt.ee6a59700c16c1b9c3afa5b6800310d0.svg";
export { ForwardRef as ReactComponent };